export default function API (method = 'GET', path='', params='', querys={}, type="application/json", init={}, bearer=""){
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", type);
    myHeaders.append("key", "ki99=9!2?^8|DVUWzwzX");
    if(bearer!=""){
        myHeaders.append("Authorization", `Bearer ${bearer}`);
    }
    var myInit = {
        method: method,
        ...init,
        mode:"cors",
        credentials:"include",
        //headers: myHeaders
    };
    if(method==="POST" || method==="PATCH" || method==="PUT" || method==="DELETE"){
        if(type ==="multipart/form-data"){
            /*var data = new FormData()
            data.append("image",params.valeur)
            delete params.valeur*/
            /*for (const [key, value] of Object.entries(params)) {
                data.append(key,JSON.stringify(value))
            }*/
            //myInit={...myInit, body: data}
            myInit={...myInit, body: params}
        }else{
            myInit={...myInit, headers: myHeaders, body : JSON.stringify(params)}   
        }
    }else{
        myInit={...myInit, headers: myHeaders}
    }
    const url = new URL(process.env.REACT_APP_API_URL+"/"+path);
    Object.keys(querys).forEach(key => {
        if(querys[key]){
            if(typeof(querys[key])!="string") querys[key] = JSON.stringify(querys[key])
            url.searchParams.append(key, querys[key])
        }
    })

    let tmpResponse
    return fetch(url, myInit)
    .then(async response => {
        //console.log("coucou",response)
        tmpResponse = response
        if(response.status === 204){
            tmpResponse.json = []
            return tmpResponse
        }
        tmpResponse.json = await response.json()
        return tmpResponse

        /*if(response.status === 200 || response.status === 201){
            return response.json();
        }else if(response.status === 204){
            return []
        }else{

            //console.log("%cErreur "method + " - " + path)
            //return response.text();
            //return response.json();
        }
        try{
            return response.json();
        }catch(e){
            return response
        }*/
    })
    .catch(err => {
        if(err.name === "SyntaxError" && 
            (err.message.includes("nexpected") && err.message.includes("JSON") ||   //U-unexpected JSON (chrome ou firefox)
            err.message.includes("string did not match the expected pattern"))){    // idem (safari)
            return tmpResponse
        }
        throw new Error(err)
    });
}
